import './assets/button.css';
import { jsx as r } from "react/jsx-runtime";
import { forwardRefPolymorphic as E } from "@datamole/wds-std";
import f from "clsx";
import { ButtonContext as d } from "./context.js";
import { DEFAULT_SIZE as B, DEFAULT_VARIANT as _, DEFAULT_ELEMENT_TYPE as e } from "./utils.js";
const h = "_button_1ee6n_3", P = {
  button: h
}, s = (a, i) => {
  const { as: t, children: m, className: u, size: o = B, variant: n = _, ...c } = a, l = t ?? e, p = {
    ...(!t || t === e) && { type: "button" }
  };
  return /* @__PURE__ */ r(
    d.Provider,
    {
      value: {
        size: o,
        variant: n
      },
      children: /* @__PURE__ */ r(
        l,
        {
          ref: i,
          className: f(P.button, u),
          "data-variant": n,
          "data-size": o,
          ...p,
          ...c,
          children: m
        }
      )
    }
  );
};
s.displayName = "Button";
const x = E(s);
export {
  x as Button
};
